import React, { Component } from 'react';

export class Unauthorised extends Component {
    render() {
        return (
            <div>
                <span>Oops, something isn’t right. Please contact support</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Unauthorised.js